import React from 'react'
import DealsManagement from '../components/deals/DealsManagement'
import Breadcrumb from '../components/utils/Breadcrumb'

const Deals = () => {
  return (
    <div className='min-h-screen bg-gray-100 p-4 sm:p-6 lg:p-10 pt-16'>
      {/* Breadcrumb */}
      <div className='pt-10'>
        <Breadcrumb items={[
          { label: 'Dashboard', href: '/app', icon: 'bi-house' },
          { label: 'Deals', href: null, icon: 'bi-currency-dollar', isActive: true }
        ]} />
      </div>
      <DealsManagement/>
    </div>
  )
}

export default Deals